export const WALLETS_FETCH = 'wallets/FETCH';
export const WALLETS_DATA = 'wallets/DATA';
export const WALLETS_DATA_WS = 'wallets/DATA_WS';
export const WALLETS_ERROR = 'wallets/ERROR';
export const WALLETS_RESET = 'wallets/RESET';

export const WALLETS_ADDRESS_FETCH = 'wallets/ADDRESS_FETCH';
export const WALLETS_ADDRESS_DATA = 'wallets/ADDRESS_DATA';
export const WALLETS_ADDRESS_DATA_WS = 'wallets/ADDRESS_DATA_WS';
export const WALLETS_ADDRESS_ERROR = 'wallets/ADDRESS_ERROR';

export const WALLETS_WITHDRAW_FIAT_FETCH = 'wallets/WITHDRAW_FIAT_FETCH';
export const WALLETS_WITHDRAW_FIAT_DATA = 'wallets/WITHDRAW_FIAT_DATA';
export const WALLETS_WITHDRAW_FIAT_ERROR = 'wallets/WITHDRAW_FIAT_ERROR';

export const WALLETS_WITHDRAW_CCY_FETCH = 'wallets/WITHDRAW_CCY_FETCH';
export const WALLETS_WITHDRAW_CCY_DATA = 'wallets/WITHDRAW_CCY_DATA';
export const WALLETS_WITHDRAW_CCY_ERROR = 'wallets/WITHDRAW_CCY_ERROR';

export const SET_MOBILE_WALLET_UI = 'wallets/SET_MOBILE_WALLET_UI';
